import React from 'react';
import { Reveal } from './Reveal';
type Props = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: string;
  center?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  center = true
}: Props) {
  return <Reveal data-id="element-160" data-mp="3f2n5xuqe6mpf">
      <div className={center ? 'text-center max-w-2xl mx-auto' : 'max-w-2xl'} data-id="element-161" data-mp="3f2x0zwqank1z">
        {eyebrow && <div className={`flex items-center gap-3 mb-4 ${center ? 'justify-center' : ''}`} data-id="element-162" data-mp="3k29jy6e1o6za">
            <span className="h-px w-8 bg-gold/60" data-id="element-163" data-mp="bl58mh88wy39" />
            <span className="text-gold text-xs font-medium tracking-[0.3em] uppercase" data-id="element-164" data-mp="gjq11uh9adh5">
              {eyebrow}
            </span>
            <span className="h-px w-8 bg-gold/60" data-id="element-165" data-mp="1u0wrqdv9tcn" />
          </div>}
        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold leading-tight" data-id="element-166" data-mp="6slm2urkysmb">
          {title}
        </h2>
        {subtitle && <p className="mt-4 text-white/60 text-sm sm:text-base leading-relaxed" data-id="element-167" data-mp="uhemp4j5don9">{subtitle}</p>}
      </div>
    </Reveal>;
}